import { Link } from "react-router-dom";
import { Receipt } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LegalFooter } from "@/components/LegalFooter";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 py-8 flex flex-col">
      <div className="mx-auto w-full max-w-4xl space-y-6 flex-1">
        <div className="flex items-center justify-between gap-3">
          <Button variant="outline" size="sm" asChild>
            <Link to="/">Back to Workshop</Link>
          </Button>
        </div>

        <section className="glass-panel rounded-3xl p-6 sm:p-8">
          <div className="flex items-center gap-4">
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-primary/10">
              <Receipt className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">Refund Policy</h1>
              <p className="text-sm text-muted-foreground mt-2">
                No refund policy. As an online product, no refunds are accepted.
              </p>
            </div>
          </div>
        </section>

        <section className="glass-panel rounded-2xl p-6 space-y-4">
          <p className="text-sm text-muted-foreground">
            For digital downloads, consumers must waive their cancellation rights before digital content can be
            provided.
          </p>
          <p className="text-sm text-muted-foreground">
            Once a consumer/customer has downloaded the content, they have given up their consumer rights to a
            refund.
          </p>
        </section>

        <section className="glass-panel rounded-2xl p-6 space-y-4">
          <h2 className="text-lg font-semibold text-foreground">AI tokens</h2>
          <p className="text-sm text-muted-foreground">
            AI tokens are non-refundable. This applies to AI tokens granted as part of a paid subscription and to
            AI tokens purchased separately as top-up packs. Subscription-granted AI tokens expire 30 days after
            they are granted and do not roll over; purchased token packs do not expire. Token allowances are not
            pro-rated when a subscription is cancelled or downgraded.
          </p>
        </section>
      </div>
      <LegalFooter />
    </div>
  );
}
